import * as React from "react";
const SvgEclipse = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 10 10", fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 5, cy: 5, r: 5 }));
export default SvgEclipse;
